import { render, staticRenderFns } from "./CategoryPicker.vue?vue&type=template&id=a0e477f6"
import script from "./CategoryPicker.vue?vue&type=script&lang=js"
export * from "./CategoryPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports